import { ReactElement } from 'react';
import { CampaignName } from 'src/common/enums/campaigns';
import { AppFeatures } from 'src/common/interfaces/growthbook-generated-types';
import madhatIcon from 'src/images/pngs/campaigns/influencers/madhat-icon.png';
import beardedITDadIcon from 'src/images/pngs/campaigns/influencers/bearded-it-dad-icon.png';
import { ReactComponent as PT1Icon } from 'src/images/svgs/campaigns/influencers/pt-1-influencer-icon.svg';
import tylerRamsbeyIcon from 'src/images/pngs/campaigns/influencers/tyler-ramsbey-icon.png';
export type InfluencerCampaigns = CampaignName.MADHAT_2025 | CampaignName.THE_BEARDED_IT_DAD_2025 | CampaignName.TYLER_RAMSBEY_2025;
export const influencerCampaignValues = ([CampaignName.MADHAT_2025, CampaignName.THE_BEARDED_IT_DAD_2025, CampaignName.TYLER_RAMSBEY_2025] as const);
export type InfluencerAdditionalConfigs = Record<InfluencerCampaigns, {
  userFriendlyName: string;
  landingRedirect: string;
  detailsRedirect: string;
  urlToNavigate: string;
  page: string;
  details: string;
  pagesToShowCTA: string[];
  barCta: (userFriendlyName: string, percentageOff: number, isOnboarding: boolean) => ReactElement;
  featureFlag: keyof AppFeatures;
  percentageOff: number;
  icon: string;
  InfluencerIcon: React.FC<React.SVGProps<SVGSVGElement>>;
}>;
const barCta = (userFriendlyName: string, percentageOff: number, isOnboarding: boolean): ReactElement => {
  if (isOnboarding) {
    return <>
        {userFriendlyName} viewers exclusive: <span>{percentageOff}% off</span> Jr Penetration Tester certification!
        Finish onboarding to claim your discount.
      </>;
  }
  return <>
      {userFriendlyName} viewers exclusive: <span>{percentageOff}% off</span> Jr Penetration Tester certification!
    </>;
};
export const INFLUENCER_ADDITIONAL_CONFIGS: InfluencerAdditionalConfigs = {
  [CampaignName.MADHAT_2025]: {
    userFriendlyName: 'MadHat',
    landingRedirect: '/certification/junior-penetration-tester?utm_source=youtube&utm_medium=social&utm_campaign=MadHat_PT1',
    detailsRedirect: '/certification/junior-penetration-tester/details?utm_source=youtube&utm_medium=social&utm_campaign=MadHat_PT1',
    urlToNavigate: '/login?source=madhat',
    page: '/certification/junior-penetration-tester',
    details: '/certification/junior-penetration-tester/details',
    pagesToShowCTA: ['/certification/junior-penetration-tester', '/welcome', '/dashboard/*'],
    barCta,
    featureFlag: 'influencer-madhat',
    percentageOff: 25,
    icon: madhatIcon,
    InfluencerIcon: PT1Icon
  },
  [CampaignName.THE_BEARDED_IT_DAD_2025]: {
    userFriendlyName: 'The Bearded I.T. Dad',
    landingRedirect: '/certification/junior-penetration-tester?utm_source=youtube&utm_medium=social&utm_campaign=Dakota_PT1',
    detailsRedirect: '/certification/junior-penetration-tester/details?utm_source=youtube&utm_medium=social&utm_campaign=Dakota_PT1',
    urlToNavigate: '/login?source=thebeardeditdad',
    page: '/certification/junior-penetration-tester',
    details: '/certification/junior-penetration-tester/details',
    pagesToShowCTA: ['/certification/junior-penetration-tester/*', '/certification/junior-penetration-tester/details', '/welcome', '/dashboard/*'],
    barCta,
    featureFlag: 'influencer-the-bearded-it-dad',
    percentageOff: 25,
    icon: beardedITDadIcon,
    InfluencerIcon: PT1Icon
  },
  [CampaignName.TYLER_RAMSBEY_2025]: {
    userFriendlyName: 'Tyler Ramsbey',
    landingRedirect: '/certification/junior-penetration-tester?utm_source=youtube&utm_medium=social&utm_campaign=Tyler_PT1',
    detailsRedirect: '/certification/junior-penetration-tester/details?utm_source=youtube&utm_medium=social&utm_campaign=Tyler_PT1',
    urlToNavigate: '/login?source=tylerramsbey',
    page: '/certification/junior-penetration-tester',
    details: '/certification/junior-penetration-tester/details',
    pagesToShowCTA: ['/certification/junior-penetration-tester', '/welcome', '/dashboard/*'],
    barCta,
    featureFlag: 'influencer-tyler-ramsbey',
    percentageOff: 25,
    icon: tylerRamsbeyIcon,
    InfluencerIcon: PT1Icon
  }
};
export function isInfluencerCampaignKey(key: string): key is InfluencerCampaigns {
  return key in INFLUENCER_ADDITIONAL_CONFIGS;
}